import React, { useState, useEffect } from 'react';
import PartFirstTab from './components/PartFirstTab';
import PartSecondTab from './components/PartSecondTab';
import PartThirdTab from './components/PartThirdTab';
import PartFourTab from './components/PartFourTab';
import Header from '../../components/Header';
import TabScrollButton from '@mui/material/TabScrollButton';
import { MdArrowUpward } from 'react-icons/md'; // Import the scroll-to-top icon
import TextField from '@mui/material/TextField';
import { ToastContainer, toast } from 'react-toastify';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

 import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import "./stepper.css";
import { TiTick } from "react-icons/ti";
import AlertDialogSlide from './components/modal/AlertDialogSlide';
import Footer from '../../components/Footer';
import { partIVQuestions } from './Questions';
import { useNavigate } from 'react-router-dom';
import AlertDialog from './components/modal/AlertDialog';
import { Avatar, Typography } from '@mui/material';

const TOAST_ID = 'toast-unique-id';
const MainModalNew = ({user,setReload}) => {
    console.log("user",user.USER_NAME)
  const [isModalOpen, setIsModalOpen] = useState(false);



  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [name, setName] = useState('');
  const [age, setAge] = useState('');
  const [course, setCourse] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] =useState('');
  const [collegeName, setCollegeName ] =useState('');
  const [schoolName, setSchoolName ] =useState('');
  const [grade, setGrade] =useState('');
  const [section, setSection] =useState('');
  const [companyName, setCompanyName] =useState('');
  const [role, setRole] =useState('');
  const [edu, setEdu]=useState('');
const navigate=useNavigate()


  const steps = ["Part I", "Part II", "Part III", "Part IV"];
const [emailError, setEmailError] =useState('');
const [nameError, setNameError] = useState('');
const [ageError, setAgeError]= useState('');
const [courseError, setCourseError] =useState('');
const [phoneError, setPhoneError] =useState('');
const [gradeError, setGradeError] =useState('');
const [sectionError, setSectionError] =useState('');
const [companyNameError, setCompanyNameError] =useState('');
const [roleError, setRoleError] =useState('');
const [eduError, setEduError] =useState('');


  const [selectedOption, setSelectedOption] = useState(''); // Default value



  const [selectedAnswersPartI, setSelectedAnswersPartI] = useState({});
  const [selectedAnswersPartII, setSelectedAnswersPartII] = useState({});
  const [selectedAnswersPartIII, setSelectedAnswersPartIII] = useState([]);
  const [selectedAnswersPartIV, setSelectedAnswersPartIV] = useState({});


  

 

  useEffect(() => {
    if (Object.keys(selectedAnswersPartIV).length === 0) {
      const defaultAnswers = partIVQuestions.reduce((acc, question) => {
        acc[question.id] = 1; 
        return acc;
      }, {});
      setSelectedAnswersPartIV(defaultAnswers);
    }
 
  }, [selectedAnswersPartIV, setSelectedAnswersPartIV,user]);




  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  const formattedData = {
    value: {
      ...selectedAnswersPartIV,
    },
    interest: selectedAnswersPartIII.map(String),
    personality: [
      ...Object.entries(selectedAnswersPartI).flatMap(([key, value]) => {
        if (Array.isArray(value)) {
          // If the value is an array (e.g., for question 25), return each selection separately
          return value.map((v) => `${key}${v}`);
        }
        // Otherwise, handle as a single value
        return `${key}${value}`;
      }),
      ...Object.entries(selectedAnswersPartII).map(([key, value]) => `${key}${value}`),
    ],
  };


  




  
  
  useEffect(() => {
    setIsModalOpen(true);
    if(user){
         setSelectedOption(user.USER_TYPE)
    }
  }, [user]);


  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);



  const closeModal = () => {
    
    

    






    setIsModalOpen(false);


    

  
    

  };



  const handleNext = () => {
    if (currentStep < steps.length) {
      setCurrentStep((prev) => prev + 1);
    } else {
      setComplete(true); // Mark the stepper as complete
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleStepClick = (step) => {

    setCurrentStep(step);
  };


  const handleRadioChange =(event)=>{
    setSelectedOption(user.USER_TYPE);
    
  }



  const handleSubmitModal = () => {
    setOpen(true);
  }


  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);


   useEffect(() => {
    if (!user) {
      const userToken = sessionStorage.getItem('fytn_token');
      if (userToken) {
        navigate(`/test/${userToken}`);
      }
    }
  }, [user, navigate]);

  if (!user) return null;

  return (
    <>

    <Header userName={user.USER_NAME} />
    <ToastContainer />
      
      <div className=" bg-gray-100 mb-10">
    
      <div className="stepper-container bg-gray-100">
  <div className="stepper-content">
   
    <div className="flex justify-between flex-wrap">
  
      {steps.map((step, i) => (
        <div
          key={i}
          className={`cursor-pointer step-item ${currentStep === i + 1 && "active"} ${(i + 1 < currentStep || complete) && "complete"}`}
          onClick={() => handleStepClick(i + 1)} // Handle click on step item
        >
          <div className="step">
            {i + 1 < currentStep || complete ? <TiTick size={24} /> : i + 1}
          </div>
          <p className="text-gray-500">{step}</p>
        </div>
      ))}
    </div>
    <Box sx={{display:"flex",gap:8,justifyContent:"space-between" }}>
    <button
      type="button"
      onClick={handleSubmitModal}
      className=" res-button cursor-pointer submit-btn">
      Submit Test
    </button>
    

          {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1,}}>
        <Avatar alt={user.USER_NAME} />
        <Typography variant="subtitle1" fontWeight="500">{user.USER_NAME}</Typography>
      </Box> */}
          </Box>
  </div>

</div>


        {/* Render the content for each step */}
        <div className="bg-gray-100  " style={{ marginTop: "160px" }}>
          {currentStep === 1 && <PartFirstTab selectedAnswersPartI={selectedAnswersPartI}
            setSelectedAnswersPartI={setSelectedAnswersPartI} />}
          {currentStep === 2 && <PartSecondTab selectedAnswersPartII={selectedAnswersPartII}
            setSelectedAnswersPartII={setSelectedAnswersPartII} />}
          {currentStep === 3 && <PartThirdTab selectedAnswersPartIII={selectedAnswersPartIII}
            setSelectedAnswersPartIII={setSelectedAnswersPartIII} />}
          {currentStep === 4 && <PartFourTab questions={partIVQuestions} selectedAnswersPartIV={selectedAnswersPartIV}
            setSelectedAnswersPartIV={setSelectedAnswersPartIV} />}
        </div>
<div>
    
</div>


                {/* Scroll to Top Button */}
                {showScrollTop && (
          <button
            onClick={handleScrollToTop}
            className=" p-4 scroll-to-top-button fixed bottom-20 right-8 bg-blue-500 text-white text-center rounded-full shadow-lg hover:bg-blue-600 transition"
          >
                        <MdArrowUpward size={24} />

          </button>
        )}


        {/* Back and Next buttons */}
        <div className=" container bg-gray-100 mx-auto justify-center items-center px-6 ">
          <div className="flex parts pl-24 pr-24 justify-between items-center pb-10" >
            <button
              onClick={handleBack}
              className={`btn  text-gray-700 px-4 py-2 rounded ${currentStep === 1 ? " bg-gray-200 opacity-50 cursor-not-allowed" : "bg-blue-500 text-white"}`}
              disabled={currentStep === 1}
            >
              Back
            </button>
            <button
              onClick={currentStep === steps.length ? handleSubmitModal : handleNext}
              className="btn bg-blue-500 text-white px-4 py-2 rounded"
            >
              {currentStep === steps.length ? "Finish" : "Next"}
            </button>
          </div>
        </div>




        <
          AlertDialog
          open={open} setOpen={setOpen} 
         
         
     user={user}
          
          
          
          formattedData={formattedData} error={error} setError={setError} 
          selectedAnswersPartI ={selectedAnswersPartI}
          selectedAnswersPartII = {selectedAnswersPartII}
          selectedAnswersPartIII = {selectedAnswersPartIII}
          setReload={setReload}
          
          />
   


<Modal
  open={isModalOpen}
  onClose={(event, reason) => {
    if (reason !== 'backdropClick') {
      closeModal();
    }
  }}
  aria-labelledby="modal-title"
  aria-describedby="modal-description"
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: '90%', sm: 600 }, // Responsive width
      maxHeight: '90vh', // Maximum height with scroll
      overflowY: 'auto', // Enable vertical scrolling
      bgcolor: 'background.paper',
      
      boxShadow: 24,
      // p: { xs: 2, sm: 4 }, // Responsive padding
     
    }}
  >
    <div className="w-full">
      {/* Header */}
      <div
        className="pl-4 pt-2 pb-2 flex justify-between items-center mb-4"
        style={{
          backgroundColor: '#Ffc71a',
        }}
      >
        <div className="modal-header text-lg font-bold">Personal Details</div>
      </div>

      {/* Input Fields */}
      <div className='pl-8 pr-8 '>
      <div className="modal-content grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Name */}
        <div>
          <label className="block text-lg font-medium">
            Name <span className="text-red-600">*</span>
          </label>
          <TextField
            placeholder="Enter Name"
            value={user.USER_NAME}
            variant="outlined"
            disabled
            fullWidth
          />
        </div>

        {/* Age */}
        <div>
          <label className="block text-lg font-medium">
            Age <span className="text-red-600">*</span>
          </label>
          <TextField
            placeholder="Enter Age"
            value={user.USER_AGE}
            variant="outlined"
            disabled
            fullWidth
          />
        </div>

        {/* Phone No */}
        <div>
          <label className="block text-lg font-medium">
            Phone No. <span className="text-red-600">*</span>
          </label>
          <TextField
            placeholder="Enter Phone No."
            value={user.USER_PHONE_NO}
            variant="outlined"
            disabled
            fullWidth
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-lg font-medium">
            Email <span className="text-red-600">*</span>
          </label>
          <TextField
            placeholder="Enter Email"
            value={user.USER_EMAIL}
            variant="outlined"
            fullWidth
            disabled
          />
        </div>
      </div>

      {/* RadioGroup Section */}
   <div className="mt-4 flex justify-around">
        <RadioGroup
          row
          aria-labelledby="demo-radio-buttons-group-label"
          name="radio-buttons-group"
          value={user.USER_TYPE}
          
           sx={{
          gap: 6, // Default gap between radio buttons
          display: 'flex', // Ensure flexbox display
          flexWrap: 'nowrap', // Prevent wrapping (keep all buttons in a row)
          
          '@media (max-width: 1200px)': {
            gap: '15px', 
          },
          '@media (max-width: 400px)': {
            gap: '4px', 
          },
        }}
        >
          <FormControlLabel
            value="COLLEGE"
            control={<Radio />}
            disabled
            label="College"
          />
          <FormControlLabel
            value="SCHOOL"
            control={<Radio />}
            disabled
            label="School"
          />
          <FormControlLabel
            value="PROFESSIONAL"
            control={<Radio />}
            disabled
            label="Professional"
          />
        </RadioGroup>
      </div>

      {/* Dynamic Fields Based on Selected Option */}
      {selectedOption === 'COLLEGE' && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          <div>
            <label className="block text-lg font-medium">
              Course <span className="text-red-600">*</span>
            </label>
            <TextField
              placeholder="Enter Course"
              value={user.USER_COURSE}
              variant="outlined"
              disabled
              fullWidth
            />
          </div>
          <div>
            <label className="block text-lg font-medium">
              College <span className="text-red-600">*</span>
            </label>
            <TextField
              placeholder="Enter College Name"
              value={user.INSTITUTION_NAME}
              variant="outlined"
              disabled
              fullWidth
            />
          </div>
        </div>
      )}

      {selectedOption === 'SCHOOL' && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          <div>
            <label className="block text-lg font-medium">
              Grade <span className="text-red-600">*</span>
            </label>
            <TextField
              placeholder="Enter Grade"
              value={user.USER_GRADE.split('-')[0]}
              variant="outlined"
              disabled
              fullWidth
            />
          </div>
          <div>
            <label className="block text-lg font-medium">
              Section <span className="text-red-600">*</span>
            </label>
            <TextField
              placeholder="Enter Section"
              value={user.USER_GRADE.split('-')[1]}
              variant="outlined"
              disabled
              fullWidth
            />
          </div>
          <div>
            <label className="block text-lg font-medium">
              School <span className="text-red-600">*</span>
            </label>
            <TextField
              placeholder="Enter School Name"
              value={user.INSTITUTION_NAME}
              disabled
              variant="outlined"
              fullWidth
            />
          </div>
        </div>
      )}

      {selectedOption === 'PROFESSIONAL' && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          <div>
            <label className="block text-lg font-medium">
              Company <span className="text-red-600">*</span>
            </label>
            <TextField
              placeholder="Enter Company Name"
              value={user.COMPANY_NAME}
              variant="outlined"
              disabled
              fullWidth
            />
          </div>
          <div>
            <label className="block text-lg font-medium">
              Role <span className="text-red-600">*</span>
            </label>
            <TextField
              placeholder="Enter Role"
              value={user.USER_COMPANY_ROLE}
              variant="outlined"
              disabled
              fullWidth
            />
          </div>
          <div>
            <label className="block text-lg font-medium">
              Highest Education <span className="text-red-600">*</span>
            </label>
            <TextField
              placeholder="Enter Highest Education"
              value={user.USER_COMPANY_HIGHER_EDUCATION}
              variant="outlined"
              disabled
              fullWidth
            />
          </div>
        </div>
      )}
</div>
      {/* Submit Button */}
      <div className="flex justify-center mt-6 mb-2">
        <button
          onClick={closeModal}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007BFF',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '5px',
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  </Box>
</Modal>

      </div>

      

      <Footer />

    </>
  );
};

export default MainModalNew;
